<template>
  <div class="product-page">
    <main id="main-content">
      <ComputingPowerHeroSection />
      <ComputingPowerFeaturesSection />
      <ComputingPowerInstancesSection />
      <ComputingPowerDatacentersSection />
      <ComputingPowerUseCasesSection />
    </main>
  </div>
</template>

<script setup lang="ts">
import ComputingPowerDatacentersSection from '@/components/computing-power/ComputingPowerDatacentersSection.vue';
import ComputingPowerFeaturesSection from '@/components/computing-power/ComputingPowerFeaturesSection.vue';
import ComputingPowerHeroSection from '@/components/computing-power/ComputingPowerHeroSection.vue';
import ComputingPowerInstancesSection from '@/components/computing-power/ComputingPowerInstancesSection.vue';
import ComputingPowerUseCasesSection from '@/components/computing-power/ComputingPowerUseCasesSection.vue';
import { useSeo } from '@/composables/useSeo';
import '@/styles/newhome/product-page.css';

useSeo({
  title: '海曦全栈式云算力服务｜七大区域机房覆盖，弹性算力租赁，软硬件一体化端到端极速交付',
  description:
    '海曦搭建多座国标A级、T3+等级算力机房，可提供x86、海光、ARM、英伟达GPU等多规格算力实例；支持秒级资源扩缩、按实际用时计费，节点依托RDMA高速互联，服务可靠性达99.95%；可快速交付百卡至万卡集群，适配渲染、科学计算、AI训练、云游戏等场景，配备合规资质与全天候运维保障。'
});
</script>
